const defineTimeout = (promise, time = 1000) => {
	let timer;
	return Promise.race([
		promise,
		new Promise((resolve, reject) => timer = setTimeout(resolve, time))
	]).finally(() => clearTimeout(timer));
}

export default defineTimeout;